import { event } from '@uhg-abyss/web/tools/event';
import { logger } from '@uhg-abyss/web/tools/logger';
import { createScript } from '@uhg-abyss/web/tools/script';
import { uniqueId } from '@uhg-abyss/web/tools/uniqueId';

export const asyncMessaging = (options) => {
  if (options.enabled !== false) {
    const generatedUniqueId = uniqueId();
    const { hostname } = window.location;
    const scriptHost =
      hostname === 'secure.uhcprovider.com'
        ? 'https://maelstrom-dmz.uhc.com'
        : 'https://maelstrom-dmz-nonprod.uhc.com';

    const scriptSrc = `${scriptHost}/cdn/uhcp/scripts/pi-async-chat-scripts.js?id=${generatedUniqueId}`;

    createScript('async-msg-lp-chat-script', scriptSrc);
  }

  return {
    id: options.id,
    events: options.events,
    metadata: options.metadata,
    trigger: (tag) => {
      event.debounce(tag, 100, () => {
        if (options.logging) {
          logger.warn(`chat: ${tag.event}`, tag.data);
        }

        if (window.startLiveperson) {
          logger.log('Starting LivePerson Script, Tag info -', tag);
          // arg 1 : provider data, arg 2: userinfo url
          window.startLiveperson(tag.data, '/api/identity/ohid/userinfo');
        }
      });
    },
  };
};
